import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardChoose = ({
    titleRedCaps,
    text,
    classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="text-title">
			<h4>{titleRedCaps}</h4>
		</div>
		<div className="content-body">{text}</div>
	</StyledCard>
);

PropTypes.Card = {
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default CardChoose;
